import { render } from "./PasswordResetActionForm.vue?vue&type=template&id=11a1383c"
import script from "./js/passwordResetActionForm.js?vue&type=script&lang=js&external"
export * from "./js/passwordResetActionForm.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__